import { Navigate, Outlet, useOutletContext } from 'react-router-dom'
import { useAuth } from '@/providers/AuthProvider'
import { useLocationRef } from '@/contexts/RefContext'
import { PATHS } from '@/router/paths'

interface AlreadyAuthProps {
	redirectTo?: (ref: string) => string
}

export function AlreadyAuth({ redirectTo }: AlreadyAuthProps) {
	const { isAuthenticated } = useAuth()
	const locationRef = useLocationRef()
	// Forward whatever context the parent outlet passed (e.g. MenuLayoutContext) so
	// child routes like AccountEntryPage can still read it via useOutletContext().
	const parentContext = useOutletContext()

	if (isAuthenticated) {
		return <Navigate to={(redirectTo ?? PATHS.menu)(locationRef)} replace />
	}

	return <Outlet context={parentContext} />
}
